// DE: Grundzutaten, die immer im Haus sind: Sie werden nie eingekauft und gelten nie als fehlend.
// EN: Staples that are always at home: they are never bought and never count as missing.
export const STAPLE_PRODUCT_IDS: readonly string[] = [
  'salt',
  'pepper',
  'oil',
  'paprika_powder',
  'curry',
  'herbs',
];
